import { Component, OnInit , OnDestroy , ViewChild , Inject  } from '@angular/core';
import {Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { ServerService } from '../../../service/server/server.service';
import { MAT_DIALOG_DATA , MatDialog , MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-server-backend-codes',
  templateUrl: './server-backend-codes.component.html',
  styleUrls: ['./server-backend-codes.component.css']
})
export class ServerBackendCodesComponent implements OnInit , OnDestroy {
  public username:any;
  public lang:any;
  public loading = false; 
  public subscription:Subscription;
  public err:string;public err_validation:boolean=false;
  public err_internet_text:string;public err_internet_validation:boolean;
  public server:any;
  public id:number;
  public codes:any;
  public title:string;
  public list_codes:any=[];

  
  constructor(public serverService:ServerService , public router:Router , @Inject(MAT_DIALOG_DATA) public dialog_data:any
  , public dialogRef:MatDialogRef<ServerBackendCodesComponent>) {
    this.id = this.dialog_data.id;
  }//end consructor
  
  ngOnInit() {
    this.serverService.status1(2);
    this.server = this.serverService.get_server();
    this.username = localStorage.getItem("username");
    this.lang = localStorage.getItem("lang");
    this.recieve_codes();
  }


  recieve_codes(){ 
    if(this.serverService.check_internet()['status'] == false){
     this.err_internet_validation=true;
     this.err_internet_text=this.serverService.check_internet()['title'];
     return;
    }//end if
	else{this.err_internet_validation=false;}
    this.subscription = this.serverService.post_address(this.server,'get_sever_backend_codes',{id:this.id}).subscribe(    
     (res)=>{
      if(res['status'] == 1 ){
        this.codes = res['result'][0].project_service_codes;
        this.title = res['result'][0].project_service_title;
       this.recieve_erorr(false,false,"","",1);
      }//end if
      else{
       this.recieve_erorr(true,true,'Erorr in recieve',"خطا در دريافت",1);
      }
     }
    ) 
  }//end recieve_data

  update(){
    if(this.serverService.check_internet()['status'] == false){
      this.err_internet_validation=true;
      this.err_internet_text=this.serverService.check_internet()['title'];
      return;
     }//end if
     else{this.err_internet_validation=false;}
     this.loading=true; 
     this.subscription = this.serverService.post_address(this.server,'project_service_init_update',{"username" : this.username , 'codes' : this.codes , 'id' : this.id , 'type_update' : 2  }).subscribe(  
      (res)=>{
       if(res['status'] == 1 ){
        this.codes = res['result'][0].project_service_codes; 
        this.recieve_erorr(false,false,"","",1);
       }//end if
       else{
        this.recieve_erorr(true,true,'Erorr in save',"خطا در ذخيره",1);
       }
      }    
     );
  }

  close(){
   this.dialogRef.close();
  }//end close
  //**************************************************
  recieve_erorr(err_validation,loading,en_message,pe_message,type){
   this.err_validation=err_validation; 
   if(type == 1 ) this.loading=false; 
   this.err=pe_message;
  }//end 
  //*******************************************************************************
  ngOnDestroy():void{
   if(this.subscription){
    this.subscription.unsubscribe();
   }//end if
  }//end OnDestroy
}

